export const KeyTmsCodes = {
    recoMobileRenewal: {
        zid: 'care-digital_accueil_marchand_mobile-changermobile',
        zidMob: 'care-digital_accueil-mob_marchand_mobile-changermobile',
        zidSosh: 'care-digital_accueil-sosh_marchand_mobile-changermobile',
        zidSoshMob: 'care-digital_accueil-sosh-mob_marchand_mobile-changermobile',
    },
    recoMobileOffer: {
        zid: 'care-digital_accueil_marchand_changeroffre-mobile',
        zidMob: 'care-digital_accueil-mob_marchand_changeroffre-mobile',
        zidSosh: 'care-digital_accueil-sosh_marchand_changeroffre-mobile',
        zidSoshMob: 'care-digital_accueil-sosh-mob_marchand_changeroffre-mobile',
    },
    recoHomeOffer: {
        zid: 'care-digital_accueil_marchand_changeroffre-home',
        zidMob: 'care-digital_accueil-mob_marchand_changeroffre-home',
        zidSosh: 'care-digital_accueil-sosh_marchand_changeroffre-home',
        zidSoshMob: 'care-digital_accueil-sosh-mob_marchand_changeroffre-home',
    },
    recoMobile: {
        zid: 'care-digital_accueil_marchand_mobile',
        zidMob: 'care-digital_accueil-mob_marchand_mobile',
        zidSosh: 'care-digital_accueil-sosh_marchand_mobile',
        zidSoshMob: 'care-digital_accueil-sosh-mob_marchand_mobile',
    },
    recoHome: {
        zid: 'care-digital_accueil_marchand_home',
        zidMob: 'care-digital_accueil-mob_marchand_home',
        zidSosh: 'care-digital_accueil-sosh_marchand_home',
        zidSoshMob: 'care-digital_accueil-sosh-mob_marchand_home',
    },
    recoEntertainement: {
        zid: 'care-digital_accueil_marchand_divertissement',
        zidMob: 'care-digital_accueil-mob_marchand_divertissement',
        zidSosh: 'care-digital_accueil-sosh_marchand_divertissement',
        zidSoshMob: 'care-digital_accueil-sosh-mob_marchand_divertissement',
    },
    recosetTopBox: {
        zid: 'care-digital_accueil_marchand_divertissement',
        zidMob: 'care-digital_accueil-mob_marchand_divertissement',
        zidSosh: 'care-digital_accueil-sosh_marchand_divertissement',
        zidSoshMob: 'care-digital_accueil-sosh-mob_marchand_divertissement',
    },
};
